"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWidgetFactory = void 0;
var WidgetLibrary_1 = require("./WidgetLibrary");
var findWidget = function (tag, additionalWidgets) {
    var allWidgets;
    if (additionalWidgets)
        allWidgets = __spreadArray(__spreadArray([], additionalWidgets), WidgetLibrary_1.widgets);
    else
        allWidgets = WidgetLibrary_1.widgets;
    return allWidgets.filter(function (x) { return x.shortcode === tag; })[0];
};
var useWidgetFactory = function (additionalWidgets) {
    return {
        findWidget: function (tag) { return findWidget(tag, additionalWidgets); },
    };
};
exports.useWidgetFactory = useWidgetFactory;
//# sourceMappingURL=WidgetsFactory.js.map